export interface FrontConfigGlobals {
  MAIN_APP_URL: string;
  FRONT_ENV: string;
}

// The `FRONT_CONFIG` variable is replaced at build time by the right object by webpack.DefinePlugin (see `survey/webpack/buildWebpackFrontConfig.js`)
declare const FRONT_CONFIG: FrontConfigGlobals;

export const FrontConfig = FRONT_CONFIG;
